module.exports = __webpack_public_path__ + "4-81.jpg?27143287b153237528fc60cae4938f5a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-81.jpg
// module id = 162
// module chunks = 0